import React from 'react';
import logo from '../logo.svg';
import '../css/App.scss';
import Header from './Header';
import Footer from './Footer';
import AppBody from './AppBody';
import { BrowserRouter } from 'react-router-dom';

function App() {
  return (
    <BrowserRouter basename="/" >
      <div className="w-100 App">
        <Header/>
        <AppBody/>
        <Footer/>
      </div>
    </BrowserRouter>
  );
}

export default App;
